import Antd from "ant-design-vue"
import "ant-design-vue/dist/antd.css"
import { createPinia } from 'pinia'
import "swiper/swiper.scss"
import { createApp } from 'vue'
import Vue3Marquee from 'vue3-marquee'
import 'vue3-marquee/dist/style.css'
import App from './App.vue'
import "./assets/scss/index.scss"
import router from './router'

createApp(App).use(createPinia()).use(router).use(Antd).use(Vue3Marquee).mount('#app')
